import React, { useState } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import "../../newstyle.css";
import { useMutateCreateImage } from "../../hooks/useApiHook";
import { ErrorToast } from "../../../../Utils/SweetAlert";

const DiscoverImageSelect = ({
  field,
  Label,
  require,
  className,
  height,
  width,
  useArrayForImageUrl = false, // New prop to determine array or single value
}) => {
  const addImageApi = useMutateCreateImage();
  const { setFieldValue } = useFormikContext();
  const [isHovered, setIsHovered] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const handleChange = async (event) => {
    const files = event.target.files[0];
    if (files) {
      setIsImageUploading(true);

      const formData = new FormData();
      formData.append("images", files);

      addImageApi.mutate(formData, {
        onSuccess: (response) => {
          const imageUrl = response?.data[0];
          if (imageUrl) {
            // Conditionally update Formik field value as an array or a single string
            if (useArrayForImageUrl) {
              setFieldValue(field.name, [imageUrl]); // Set image URL as an array
            } else {
              setFieldValue(field.name, imageUrl); // Set image URL as a single string
            }
          }
          setIsImageUploading(false);
        },
        onError: (error) => {
          ErrorToast(error?.response?.data?.message || "Server error.");
          setIsImageUploading(false);
        },
      });
    }
  };

  return (
    <div className={className}>
      {Label && (
        <label>
          {Label} {require && <span className="text-danger">*</span>}
        </label>
      )}
      <div
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        {field.value ? (
          // Edit Image Case
          <div
            style={{ position: "relative", height, width }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={field.value}
              alt="Uploaded"
              style={{
                height,
                width,
                opacity: isHovered ? "50%" : "100%",
              }}
              className="img-border image-responsive"
            />
            <div
              className="position-absolute"
              style={{
                display: isHovered ? "block" : "none",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <label htmlFor={field.name} className="replace-btn">
                {isImageUploading ? "Uploading..." : "Replace"}
                <input
                  id={field.name}
                  type="file"
                  name={field.name}
                  accept="image/png, image/jpeg, image/jpg"
                  className="filetype d-none"
                  onChange={handleChange}
                />
              </label>
            </div>
          </div>
        ) : (
          // Add Image Case
          <label htmlFor={field.name}>
            <div
              className="image-upload addproduct-class"
              style={{ height, width }}
            >
              <div className="text-center">
                <div
                  style={{
                    padding: "30px 27px",
                    background: "#D8D4D4",
                    borderRadius: "100%",
                    color: "white",
                    fontSize: "50px",
                    display: "inline-block",
                  }}
                >
                  +
                </div>
                <br />
                <label className="disproduct-label-profile label-prod-pro">
                  {isImageUploading ? "Uploading..." : "Add Image"}
                  <input
                    id={field.name}
                    type="file"
                    name={field.name}
                    accept="image/png, image/jpeg, image/jpg"
                    className="filetype d-none"
                    onChange={handleChange}
                  />
                </label>
              </div>
            </div>
          </label>
        )}
      </div>
      <ErrorMessage name={field.name} component="div" className="text-danger" />
    </div>
  );
};

export default DiscoverImageSelect;
